export const ADMIN_ROLES = {
    ADMIN: 1,
    SUPERLIDER: 5,
};

export const ADMIN_ROUTE_ACCESS = {
    dashboard: [1, 5],

    // Rutas compartidas, pero el componente puede cambiar según el rol
    usuarios: [1, 5],
    cargaUsuarios: [1, 5],

    // Menú exclusivo Rol 5
    accesoRol5: [5],
    sesionesRol5: [5],
    evaluacionesEspecialesRol5: [5],
    championsRol5: [5],
    noticiasRol5: [5],

    // Menú actual Rol 1
    asignacionSesiones: [1],
    listadoVideos: [1],
    listadoEvaluaciones: [1],
    listadoComentarios: [1],

    asignacionChampions: [1],
    listadoDesafios: [1],

    listadoExpertos: [1],
    distribuidores: [1],

    listadoAvisos: [1],
    listadoSlider: [1],
    listadoEventos: [1],
    listadoCarrusel: [1],

    listadoMenu: [1],
    listadoPopUps: [1],
    switchHome: [1],
};

export const getAdminRoleId = (admin) => {
    return Number(admin?.rid || admin?.Rol_ID || 0);
};

export const canAccessRoute = (admin, routeKey) => {
    const rid = getAdminRoleId(admin);
    const allowedRoles = ADMIN_ROUTE_ACCESS[routeKey] || [];

    return allowedRoles.includes(rid);
};

export const hasPermission = (admin, permission) => {
    return canAccessRoute(admin, permission);
};